import { Component, Host, Event, EventEmitter, Prop, h, Listen } from '@stencil/core';

@Component({
  tag: 'jump-tab',
  styleUrl: 'jump-tab.scss',
  shadow: true,
})
export class JumpTab {
  JumpTabEl: HTMLElement;

  @Prop() disabled: boolean = false;
  @Prop() alignment: string = 'left';
  @Prop() fullBorder: boolean = false;
  @Prop() tabGroupName: string = undefined;
  @Prop() variant: string = 'inline';

  @Event({ eventName: 'jump-change-activetab' }) setActiveTab: EventEmitter;

  @Listen('jump-change-active-tab')
  changeActiveTabHandler(event: CustomEvent) {
    this.setActiveTab.emit(event.detail);

    const rootStyles = getComputedStyle(document.documentElement);
    const primaryColor = rootStyles.getPropertyValue('--neutral-grey-secondary').trim();

    let items = this.JumpTabEl.querySelectorAll('jump-tab-item');
    if (items.length > 0) {
      items.forEach((item) => {
        if (item.getAttribute('identifier') === event.detail.id) {
          item.setAttribute('active', '');

          if (this.variant === 'sheet') {
            items.forEach((sibling, index) => {
              if (sibling !== item && index !== items.length - 1) {
                sibling.style.borderRight = `1px solid ${primaryColor}`;
              } else {
                sibling.style.borderRight = '1px solid transparent';
              }
            });

            let previousSibling = item.previousElementSibling as any;
            if (previousSibling) {
              previousSibling.style.borderRight = '1px solid transparent';
            }
          }

        } else {
          item.removeAttribute('active');
        }
      });
    }

    let panel = this.JumpTabEl.querySelectorAll('jump-tab-panel');
    if (panel.length > 0) {
      panel.forEach((panel) => {
        if (panel.getAttribute('identifier') === event.detail.id) {
          panel.setAttribute('active', '');
        } else {
          panel.removeAttribute('active');
        }
      });
    }
  }

  componentDidLoad() {
    if (this.variant === 'sheet') {
      const rootStyles = getComputedStyle(document.documentElement);
      const primaryColor = rootStyles.getPropertyValue('--neutral-grey-secondary').trim();

      let items = this.JumpTabEl.querySelectorAll('jump-tab-item');
      if (items.length > 0) {
        items.forEach((item, index) => {
          if (index === items.length - 1 || item.classList.contains('active')) {
            item.style.borderRight = '1px solid transparent';
          } else {
            item.style.borderRight = `1px solid ${primaryColor}`;
          }
        });
      }
    }
  }

  render() {
    return (
      <Host class={"JumpTab " + this.variant} id={this.tabGroupName} ref={(el) => { this.JumpTabEl = el; }}>
        <div class={"Wrapper " + (this.fullBorder ? 'fullBorder' : '')}>
          <div class={"ContentWrapper ContentWrapper--Items"} style={{ '--alignment': this.getAlignment(this.alignment) }}>
            <div class={"Content " + this.variant + " " + (this.disabled ? 'disabled' : '') + " " + (this.fullBorder ? 'fullBorder' : '')} style={{ '--alignment': this.getAlignment(this.alignment) }}>
              <slot name="tab-item"></slot>
            </div>
          </div>
          <div class="ContentWrapper ContentWrapper--Panel">
            <slot name="tab-content"></slot>
          </div>
        </div>
      </Host>
    );
  }

  private getAlignment(alignment: string): string {
    switch (alignment) {
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default:
        return 'flex-start';
    }
  }
}
